import http from './http';

export function fetchUsageDetails(params) {
  return http.get('/usage-details', {
    params
  });
}

export function fetchTimeoutCompensationPreview() {
  return http.get('/usage-details/timeout-compensation/preview');
}

export function claimTimeoutCompensation() {
  return http.post('/usage-details/timeout-compensation');
}
